import Header from "../components/Header";
import Footer from "../components/Footer";
import Hero from "./landing/Hero";
import About from "./landing/About";
import Vibe from "./landing/Vibe";
import WhatYouGet from "./landing/WhatYouGet";
import HowItWorks from "./landing/HowItWorks";
import Faq from "./landing/Faq";

export default function Landing() {
  return (
    <>
      <a href="#main" className="skip-link">
        Skip to content
      </a>
      <Header />
      <main id="main">
        <Hero />
        <About />
        <Vibe />
        <WhatYouGet />
        <HowItWorks />
        <Faq />
      </main>
      <Footer />
    </>
  );
}
